var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfography(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m98.69 353.5c-53.95 0-98.69-43.74-98.69-97.5s44.74-97.5 98.5-97.5c24.976.059 48.281 9.712 65.83 27.173l59.941 59.692c5.891 5.86 5.898 15.402 0 21.27l-59.956 59.692c-17.534 17.461-40.839 27.114-65.625 27.173z",
    fill: "#ff641a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m413.5 353.5c-38.818 0-55.21-16.479-74.194-35.581-3.002-2.985-54.883-54.572-51.577-51.284-5.894-5.864-5.898-15.402 0-21.27 3.002-2.985 54.869-54.557 51.563-51.27 18.998-19.101 35.404-35.595 74.208-35.595 53.76 0 98.5 43.74 98.5 97.5s-44.74 97.5-98.5 97.5z",
    fill: "#97d325"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-53.699 0-97.5 44.799-97.5 98.5 0 38.699 16.5 55.199 35.7 74.099 4.501 4.801 48.3 48.6 51.301 51.601 2.699 2.999 6.599 4.499 10.499 4.499s7.5-1.5 10.201-4.199c0 0 35.7-35.7 51.599-51.901 19.2-18.9 35.7-35.4 35.7-74.099 0-53.701-43.801-98.5-97.5-98.5z",
    fill: "#5ecef4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m318.1 339.699c0-.3-48.6-48.9-51.601-51.899-2.699-3.001-6.599-4.2-10.499-4.2s-7.8 1.199-10.499 4.2c-4.501 4.799-48.301 48.6-51.301 51.599-19.2 18.9-35.7 35.4-35.7 74.101 0 53.699 43.801 98.5 97.5 98.5s97.5-44.801 97.5-98.5c0-38.401-16.199-54.901-35.4-73.801z",
    fill: "#ffda2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m353.5 413.5c0 53.699-43.801 98.5-97.5 98.5v-228.401c3.9 0 7.8 1.199 10.499 4.2 3.001 2.999 51.601 51.599 51.601 51.899 19.201 18.901 35.4 35.401 35.4 73.802z",
    fill: "#fdbf00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m266.201 224.5c-2.701 2.699-6.301 4.199-10.201 4.199v-228.699c53.699 0 97.5 44.799 97.5 98.5 0 38.699-16.5 55.199-35.7 74.099-15.899 16.201-51.599 51.901-51.599 51.901z",
    fill: "#27b2eb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfography);
export default __webpack_public_path__ + "static/media/infography.d608308a7318241f745c0df4f383c3c9.svg";
export { ForwardRef as ReactComponent };